const initDoubleColumnCounters = (scope = document) => {
  scope.querySelectorAll('.doublecoltitle-count:not([data-counter-ready])').forEach((counter) => {
    counter.dataset.counterReady = 'true';
    const start = Number(counter.dataset.start) || 0;
    const increment = Number(counter.dataset.increment) || 0;
    const formatter = new Intl.NumberFormat('en-US');
    const startedAt = performance.now();

    const update = (now) => {
      const steps = Math.floor((now - startedAt) / 500);
      const value = start + (steps * increment);
      counter.textContent = formatter.format(value);
      counter._animationFrame = requestAnimationFrame(update);
    };

    counter._animationFrame = requestAnimationFrame(update);
  });
};

document.addEventListener('DOMContentLoaded', () => initDoubleColumnCounters());

if (window.acf) {
  window.acf.addAction('render_block_preview/type=double-column-title', ($block) => {
    initDoubleColumnCounters($block[0]);
  });
}